import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import {
  PermissionsActionTypes,
  LoadPermissionsSuccess,
} from './permissions.actions';
import { map } from 'rxjs/operators';
import { AuthService } from '@account-users/auth/auth.service';

@Injectable()
export class PermissionsEffects {
  @Effect()
  fethAllUserPermissions = this.actions$.pipe(
    ofType(PermissionsActionTypes.LoadPermissions),
    map(() => new LoadPermissionsSuccess(this.auth.profile.permissions)),
  );

  constructor(private actions$: Actions, private auth: AuthService) {}
}
